var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-avatar',_vm._b({staticStyle:{"cursor":"inherit"},style:({
    border: _vm.border,
  }),attrs:{"size":_vm.size,"color":_vm.border ? `#fff` : null,"title":_vm.fullName}},'v-avatar',_vm.$attrs,false),[(_vm.user && _vm.user.avatar)?_c('v-img',{staticClass:"text-center",attrs:{"src":_vm.user.avatar.url}}):_c('h1',{staticClass:"title",style:({
      fontSize: `${_vm.size / 2.5}px !important`,
    }),domProps:{"textContent":_vm._s(_vm.initials)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }